import { render, staticRenderFns } from "./myData.vue?vue&type=template&id=91fd697e&scoped=true"
import script from "./myData.vue?vue&type=script&lang=js"
export * from "./myData.vue?vue&type=script&lang=js"
import style0 from "./myData.vue?vue&type=style&index=0&id=91fd697e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fd697e",
  null
  
)

export default component.exports